module.exports = __webpack_public_path__ + "static/media/notification_ok.d962f3d8.svg";